module.exports = __webpack_public_path__ + "static/pallets-wood-34c1843a46925d2e97e0a27054e645ba.jpg";